module.exports = __webpack_public_path__ + "static/media/St_KIlda_LOGO_1.454dedaf.svg";